import React from "react";
import { useNavigate } from "react-router-dom";
import { removeUserSession } from "../utils/Common";
import { Button } from "primereact/button";

export const Logout = () => {
  let navigate = useNavigate();

  const handleLogout = () => {
    //console.log("uklanjam sesiju");
    removeUserSession();
    //console.log("krecem navigate na root");
    navigate("/");
    //console.log("zavrsio navigate");
  };

  return (
    <div className="centerText">
      <div>
        <p className="logout-page-paragraph">
          Pritisnite gumb "Odjavite se" za odjavu sa portala
          <br />
        </p>
        <br />
        <Button
          label="Odjavi se"
          icon="pi pi-sign-out "
          className="logout-page-button"
          onClick={handleLogout}
        />
      </div>
    </div>
  );
};

export default Logout;
